import { SettingsLayout, type SettingsNavSection, type SettingsNavItem } from '@/components/settings/SettingsLayout';
import { VPN_FLOWS } from '@/features/vpnFlows';
import { useVpnPermissions } from '../permissions';

/**
 * The VPN area, `/vpn` (docs/VpnAccess.md, "Slice 6 design"): connecting, and the
 * sessions you may see. A page is one item here and one route. The organization's
 * VPN pages (sites, policies, settings) are a group under Organization Admin, with
 * the rest of what configures the organization.
 */
export function VpnLayout() {
  const { canReadSessions } = useVpnPermissions();
  const activity: SettingsNavItem[] = [
    { to: '/vpn/connect', label: 'Connect' },
    { to: '/vpn/sessions', label: 'Sessions' },
    ...(VPN_FLOWS && canReadSessions ? [{ to: '/vpn/lookup', label: 'Who was it' }] : []),
  ];
  const sections: SettingsNavSection[] = [{ label: 'VPN', visible: true, items: activity }];
  return <SettingsLayout sections={sections} ariaLabel="VPN sections" />;
}
